exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles-container-3yGmVa2v {\n  display: flex;\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.styles-currentItem-XLL5CUeL, .styles-nextItem-H9fPzbwt {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.styles-nextItem-H9fPzbwt {\n  visibility: hidden;\n}\n", ""]);

// exports
exports.locals = {
	"container": "styles-container-3yGmVa2v",
	"currentItem": "styles-currentItem-XLL5CUeL",
	"nextItem": "styles-nextItem-H9fPzbwt"
};